import { pointRepository } from '~/api/repository/point';

export const POINT_QUERY_KEY = {
  all: ['point'] as const,

  // 보유 포인트 및 발급 가능 쿠폰
  buyerPoint: () => ({
    queryKey: [...POINT_QUERY_KEY.all, 'buyer'] as const,
    queryFn: () => pointRepository.getBuyerPoint(),
  }),
};
